<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 text-center">
        <h2>Le risposte della salute: <span class="viola">Questionario OnLine</span> sulla Prevenzione</h2>
        <div class="intro">
          Obiettivo del questionario è renderti più consapevole su temi delicati come l'incidenza delle malattie
          croniche non trasmissibili, la loro prevenzione e la diagnosi precoce, l’utilità di una polizza sanitaria che
          ti aiuti a fare prevenzione. Rispondi alle domande sul tuo stile di vita, su quante persone si ammalano in
          Italia e sugli esami di controllo che esegui regolarmente.
        </div>
        <p class="margin-t-50">
          DISCLAIMER
          <br>
          Il Questionario on line ha esclusivamente finalità divulgative e di promozione della prevenzione della
          malattia senza nessuna finalità di autodiagnosi o di automedicazione.
          <br>Esso non costituisce parere professionale medico. I dati raccolti con il Questionario on line sono anonimi
          e in nessun modo riconducibili all’Utente.
          <br>
          <br>
          <small>
            Leggi le
            <a href="/privacy.pdf" target="_blank" class="text-decoration-underline">
              Note Legali e Informativa Privacy
            </a>
          </small>
        </p>
        <router-link :to="routes.survey.path" class="btn margin-b-40" v-if="canSurveyBeShown">
          RISPONDI AL QUESTIONARIO
        </router-link>
        <p v-else>
          <span class="bg-primary text-white badge badge-">Hai già risposto al questionario</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import routes from "@/core/router/routes";
import {useSettingsStore} from "@/core/stores/settings_store";
import {computed, onBeforeMount} from "vue";
import Modes from "@/core/models/Modes";

const settingsStore = useSettingsStore();
const canSurveyBeShown = computed(() => {
  return settingsStore.mode == Modes.Operator || !settingsStore.surveyCompleted;
});

onBeforeMount(() => {
  settingsStore.setMode();
});
</script>
